export const ENABLE_ACTIONS = 'ENABLE_ACTIONS';
export const GIS = 'GIS';
export const SET_HAS_POLYGON = 'SET_HAS_POLYGON';

export function enableActions() {
    return {
        type: ENABLE_ACTIONS,
    }
}

export function setGis(gis) {
    return {
        type: GIS,
        payload: gis,
    }
}